import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.module.scss'

const CounterCard = ({ count, text, image }) => {
  return (
    <div className={styles.counterCardWrapper}>
      <div className={styles.counterInfo}>
        <div className={styles.count}>{count}</div>
        <div className={styles.text}>{text}</div>
        <div className={`${styles.image} ${styles[image]}`} />
      </div>
    </div>
  )
}

CounterCard.propTypes = {
  count: PropTypes.number,
  text: PropTypes.string,
  image: PropTypes.string,
}

export default CounterCard
